/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetStripeSubscription } from "../funcs/usageGetStripeSubscription.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { StripeSubscription } from "../models/components/stripesubscription.js";
import {
  GetStripeSubscriptionRequest,
  GetStripeSubscriptionSecurity,
} from "../models/operations/getstripesubscription.js";
import { unwrapAsync } from "../types/fp.js";
export type GetStripeSubscriptionQueryData = StripeSubscription;

export function prefetchGetStripeSubscription(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetStripeSubscriptionRequest | undefined,
  security?: GetStripeSubscriptionSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetStripeSubscriptionQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetStripeSubscriptionQuery(
  client$: GramCore,
  request?: GetStripeSubscriptionRequest | undefined,
  security?: GetStripeSubscriptionSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetStripeSubscriptionQueryData>;
} {
  return {
    queryKey: queryKeyGetStripeSubscription({
      gramSession: request?.gramSession,
    }),
    queryFn: async function getStripeSubscriptionQueryFn(
      ctx,
    ): Promise<GetStripeSubscriptionQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetStripeSubscription(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetStripeSubscription(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "usage", "getStripeSubscription", parameters];
}
